import { gql } from '@apollo/client';
import { SIMPLR_EXPERT_FIELDS_FRAGMENT } from './simplrExpertFieldsFragment.gql';

export const GET_SIMPLR_EXPERT_BY_ID_QUERY = gql`
  ${SIMPLR_EXPERT_FIELDS_FRAGMENT}
  query getSimplrExpertById($simplrExpertId: String!) {
    simplrExpertGet(id: $simplrExpertId) {
      ...SimplrExpertFields
    }
  }
`;
